import PubSub from "underpub-js";

var HighlightMap = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-HighlightMap',
	};

	$.extend(true, this.options, options);

};

HighlightMap.prototype.init = function() {

	var self = this;

};

export default HighlightMap;
